import styles from "./styles.module.scss"

const spinnerSizes = {
  sm: 20,
  md: 40,
}

export const DefaultSpinner = ({
  size = "md",
  style,
}: {
  size?: keyof typeof spinnerSizes
  style?: React.CSSProperties
}) => {
  return (
    <div
      style={{
        height: spinnerSizes[size],
        width: spinnerSizes[size],
        ...style,
      }}
      className={styles.spinner}
    ></div>
  )
}
